/**
 * 周期 Tab（需求 F2.1：日/周/月/年 K线 + 分时/5日分时）
 *
 * 显示用短名（去掉「K」），悬停提示与无障碍名称用全称（日K…）。
 *
 * ⚠ 需求文档列了 1–6 等一整套快捷键，但**尚未实现**，故此处不写
 * 「（快捷键 N）」。实现快捷键时需一并处理「焦点在输入框内禁用」。
 */
import { PERIODS } from '../../lib/app';
import { useSelection } from '../../lib/selection';

export function PeriodTabs() {
  const { period, setPeriod } = useSelection();
  return (
    <div className="flex items-center" role="tablist" aria-label="K线周期">
      {PERIODS.map((p, i) => (
        <div key={p.id} className="flex items-center">
          {/* 只在分组真正交界处画线。改前是 `p.group === 2`，会在**每个**
            group=2 的 tab 前都画一条 —— 分时与 5日 之间因此凭空多出一条
            竖线和 9px 边距，看起来像「两者之间莫名有间隔」。 */}
          {i > 0 && p.group !== PERIODS[i - 1].group && (
            <span className="mx-1 h-3.5 w-px" style={{ background: 'var(--border)' }} aria-hidden />
          )}
          <button
            type="button"
            role="tab"
            aria-selected={period === p.id}
            // 可见文本是短名「日」，无障碍名称用全称「日K」——
            // 全称包含短名，满足 WCAG 2.5.3 Label in Name
            aria-label={p.full}
            onClick={() => setPeriod(p.id)}
            className="rounded px-1.5 py-0.5 text-[12px] transition-colors hover:bg-[var(--bg-hover)]"
            style={{
              background: period === p.id ? 'var(--bg-elevated)' : 'transparent',
              color: period === p.id ? 'var(--text-1)' : 'var(--text-3)',
              fontWeight: period === p.id ? 600 : 400,
            }}
            title={p.full}
          >
            {p.label}
          </button>
        </div>
      ))}
    </div>
  );
}